// src/components/search/hooks/useNewsModal.ts

import { useState } from 'react';
import { AppDispatch } from '@/app/store';
import { NewsArticle } from '@/types/news.types';
import { getImageUrl } from '@/utils/imageHelper';
import { fetchNewsDocumentUrl } from '@/features/news/newsThunks';
import { downloadFile } from '@/utils/downloadFile';

export const useNewsModal = (dispatch: AppDispatch) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<NewsArticle | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const openModal = async (article: NewsArticle) => {
    let loadedImageUrl = '/images/Logo.jpg';
    if (article.imageName) {
      try {
        const url = await getImageUrl(article.imageName);
        if (url) {
          loadedImageUrl = url;
        }
      } catch (error) {
        console.error('Error loading image:', error);
      }
    }

    setSelectedItem(article);
    setImageUrl(loadedImageUrl);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedItem(null);
    setImageUrl(null);
  };

  const downloadDocument = async () => {
    if (!selectedItem?.docName) {
      console.error('No document name provided');
      return;
    }

    try {
      const STORAGE_PATH = 'announcements/';
      const path = STORAGE_PATH + selectedItem.docName;
      const downloadUrl = await dispatch(fetchNewsDocumentUrl({ storagePath: path })).unwrap();
      await downloadFile(downloadUrl, selectedItem.docName || 'documento');
    } catch (err) {
      console.error('Error downloading document:', err);
    }
  };

  return { isOpen, selectedItem, imageUrl, openModal, closeModal, downloadDocument };
};
